// extracted by mini-css-extract-plugin
export default {"info":"FPYy","h-rule":"WD07","hRule":"WD07","logo":"dp2u","further-resources":"IJan","furtherResources":"IJan"};